<template>
<v-window v-model='activeWindow' touchless >
  <v-window-item :key='0' >
    <v-form ref="form" v-model="valid" @submit.prevent='save' lazy-validation >

    <v-card flat class='elevation-0' >
      <!-- <vuex-loader :request-id='reqId' ></vuex-loader> -->
      <v-card-title v-if='withHeader' class='overline' >
        <v-icon @click='$emit("back")' >keyboard_arrow_left</v-icon>
        {{title}}
        <v-spacer></v-spacer>
        <v-btn v-if='withClose' @click='$emit("close")' icon><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text :class='{"pa-2": $vuetify.breakpoint.xsOnly }' >
        <!-- <p v-if='editMode' class='caption' >
          <v-icon small >info</v-icon>
          <template v-if='context==="PRACTITIONER"' >This client is stored on the owners profile</template>
          <template v-else >This client is stored on the space's profile</template>
        </p> -->
        <v-layout v-if='!editMode' wrap row >
          <space-picker
            :with-select='false'
            label='Where would you like to save this client?'
            v-model='client.spaces' />
        </v-layout>

        <v-layout v-if='editMode || (client.spaces && client.spaces.length > 0)' wrap row >
          <!-- <v-flex xs12 > -->
            <v-flex xs12 >
              <server-errors :request='createRequest' >
              </server-errors>
            <!-- <pre>{{client}}</pre>
            <pre>{{clientFormatted}}</pre>
            {{contactSelectedPhone}} -->
            </v-flex>
            <v-flex xs12 class='pa-2' >
              <v-text-field
                label="Full name"
                v-model='client.full_name'
                :rules='[rules.required]'
                hint="The client's name and surname. e.g.: Jon Snow" >
              </v-text-field>
            </v-flex>
            <v-flex xs12 lg6 class='pa-2' >
              <phone-number-input
                @number='setClientPhone'
                @valid='setValidPhoneNumber'
                :short-list='["ZA"]'
                selected-country-code='ZA'
                v-model='contactSelectedPhone'
                :touch='contactSelectedPhone' >
              </phone-number-input>
            </v-flex>
            <v-flex xs12 lg6 class='pa-2' >
              <v-text-field
                label="Email"
                type='email'
                v-model='client.email'
                :rules='[rules.email]'
                hint='e-mail address. e.g.: jon@gmail.com' >
              </v-text-field>
            </v-flex>
            <v-card flat full-width width='100%' >
              <v-card-title @click='showExtra=!showExtra' class='pl-0 overline py-0' >
                <v-btn class='ml-0' v-if='showExtra===false' icon small><v-icon small >add</v-icon></v-btn>
                <v-btn class='ml-0' v-if='showExtra===true' icon small><v-icon small >remove</v-icon></v-btn>
                Extra fields
              </v-card-title>
              <v-layout row wrap v-if='showExtra' >
                <v-flex xs6 >
                  <v-text-field
                    label="Client ID"
                    v-model='client.custom_id'
                    hint='If you store some form of ID for recognizing your clients, you can use this to keep track' >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 >
                  <v-text-field
                    label="Nickname"
                    v-model='client.nickname'
                    hint='If the client has a nickname or a name that they prefer to be called by' >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card>

            <v-flex v-if='editMode' xs12 >
              <v-checkbox hide-details
                label='Update information on related appointments'
                class='mb-1 pb-0'
                v-model='updateAppointments' >
              </v-checkbox>
              <small color='primary mt-1'>
                <v-icon color='primary' small >info</v-icon>
                When you create an appointment contact information is copied to the appointment (name, phone, email).
                Select this option to have AppointmentGuru update this information on this user's appointments with your changes
              </small>
            </v-flex>
          <!-- </v-flex> -->


          <!-- <v-btn
            @click="contactSelectedPhone=phone"
            v-for='phone in ["0866959504", "+27 (82) 0070054", "0832566533", "0716026575", "(072) 6673575"]' :key='phone'
          >{{phone}}</v-btn> -->

          <!-- <transition name='fade' > -->
            <v-card v-if='contactClient && showContactClient' full-width >
              <v-card-text>
                <v-layout >
                    <v-subheader>
                      <v-icon>person</v-icon>
                      Contact details: {{contactClient.name.formatted}}</v-subheader>
                      <v-spacer></v-spacer>
                      <v-btn @click='showContactClient=false' icon><v-icon>close</v-icon></v-btn>
                </v-layout>
                <v-divider></v-divider>
                <v-layout wrap >
                  <v-flex xs12 sm6 >
                    <v-subheader>Phone numbers</v-subheader>
                    <!-- <pre
                      v-if='contactClient.phoneNumbers'
                      v-for='number in contactClient.phoneNumbers'
                      :key='number.id'>{{number}}</pre> -->

                    <v-radio-group
                      v-if='contactClient.phoneNumbers && contactClient.phoneNumbers.length > 0'
                      :mandatory="false">
                      <v-radio
                        v-for='number in contactClient.phoneNumbers'
                        @change='setSelectedNumber(number)'
                        :key='number'
                        :label="number" :value="number"></v-radio>
                    </v-radio-group>
                    <div v-else >No phone numbers found</div>
                  </v-flex>

                  <v-flex xs12 sm6 >
                    <v-subheader>Email</v-subheader>
                    <v-radio-group v-if='contactClient.emails && contactClient.emails.length > 0' v-model="contactSelectedEmail" :mandatory="false">
                      <v-radio
                        v-for='email in contactClient.emails'
                        @change='client.email = email'
                        :key='email.id'
                        :label="email" :value="email"></v-radio>
                    </v-radio-group>
                    <div v-else >No emails found</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions >
                <v-btn v-if='!editMode' flat @click='clear' >
                  Clear</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if='hasContacts' flat @click='pickContact' >
                  <v-icon>person_add</v-icon> Contacts</v-btn>
              </v-card-actions>
            </v-card>
          <!-- </transition> -->

          <v-layout class='mt-2' >
            <v-menu
              v-model='showMatchingClients'
              v-if='matchingClients && matchingClients.length > 0 && !editMode' >
              <template v-slot:activator="{ on }">
              <v-btn color="warning" v-on='on' slot='activator' outline block >
                <v-icon>warning</v-icon>
                {{ matchingClients.length }}
                Similar clients found
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
              </template>
              <span>
              <v-list dense style='width:360px' class='pa-0 elevation-10' >
                  <v-subheader class='overline grey lighten-4' >
                    Some matches found
                    <v-spacer></v-spacer>
                    <v-btn @click='showMatchingClients=false' small icon ><v-icon small >close</v-icon></v-btn>
                  </v-subheader>
                  <v-divider></v-divider>
                  <template v-for='client in matchingClients.slice(0,10)' >
                    <client-list-item
                      :with-action='false'
                      @listitem:clicked='$emit("clientselected", client.client)'
                      :relationship-id='client.id'
                      :key='client.id'
                      :client='client.client' >
                    </client-list-item>
                    <v-divider :key='`div-${client.id}`' ></v-divider>
                  </template>
                  <v-list-tile v-if='matchingClients.length > 10' >
                    <v-list-tile-content>
                      .. and {{matchingClients.length - 10}} more
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                </span>
            </v-menu>
          </v-layout>

        <!-- confirm and create -->
          <v-card class='mt-2' width='100%' >
            <v-card-title
              v-if='editMode'
              class='overline grey lighten-4 py-1'>Updated client: Please confirm</v-card-title>
            <v-card-title
              v-else
              class='overline grey lighten-4 py-1'>New client: Please confirm</v-card-title>
            <!-- && !editMode -->
            <v-divider></v-divider>

            <v-layout row wrap>
              <v-flex>
                <v-list class='pa-0' two-line v-if='client.full_name' >
                  <client-list-item
                    :relationship-id='0'
                    :client='clientFormatted' >
                    <template slot='action' >
                      <v-icon
                        v-if='clientIsValid && hasSomeContactDetails'
                        slot='action' color='success' dark >check_circle</v-icon>
                      <v-icon
                        v-if='clientIsValid && !hasSomeContactDetails'
                        slot='action' color='amber' dark >warning</v-icon>
                    </template>
                    <template v-if='!hasSomeContactDetails' slot='subtitle' >
                      <v-list-tile-sub-title >
                        <span class='yellow pa-2'><strong>Warning</strong> This client has no contact details specified</span>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title class='pl-1' >
                        You can still save this client. It's just recommended to capture some form of contact information
                      </v-list-tile-sub-title>
                    </template>
                  </client-list-item>
                </v-list>
              </v-flex>
              <v-flex xs12 class="text-right pb-0">
                <v-spacer></v-spacer>
                <vuex-btn is-block
                  :is-disabled='!clientIsValid'
                  @save='save' :req-id='reqId' :text='btnTxt' :classes='["ma-0"]' >
                </vuex-btn>
                <!-- {{client.context}}|{{sharedSpaceIds}} -->
              </v-flex>
            </v-layout>
            <p v-if='singleErrorMessage' class='warning lighten-2 pa-3 subheading' >
              <v-icon>warning</v-icon>
              {{singleErrorMessage}}</p>
          </v-card>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          @click='$emit("back")'
          v-if='withBack' flat >{{backText}}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    </v-form>
  </v-window-item>
  <v-window-item :key='1' >
    <v-list >
      <v-list-tile
        v-for='action in actions' :key='action.icon'
        @click='action.onclick(savedContact)' >
        <v-list-tile-avatar><v-icon>{{action.icon}}</v-icon></v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text='action.title' />
          <v-list-tile-sub-title v-if='action.subtitle' v-text="action.subtitle" />
        </v-list-tile-content>
        <v-list-tile-action><v-icon>chevron_right</v-icon></v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-window-item>
</v-window>
</template>
<script>
// DEFAULT_TIMEOUT
import {RULES} from '@/store/constants'
import ClientListItem from '@/components/client/ClientListItem'
import ServerErrors from '@/components/ServerErrors'
import PhoneNumberInput from '@/components/PhoneNumberInput'
import SpacePicker from '@/components/pickers/SpacePicker'
// import SpaceFaces from '@/components/lists/SpaceFaces'
import HelpPopover from '@/components/ui/HelpPopover.vue'
import { parse, format, isValidNumber } from 'libphonenumber-js'
import Vue from 'vue'

const CREATE_CLIENT_WINDOW = 0
const CLIENT_SUCCESS_WINDOW = 1

export default {
  parse,
  format,
  isValidNumber,
  name: 'CreateClient',
  components: {
    ClientListItem,
    ServerErrors,
    PhoneNumberInput,
    SpacePicker,
    // SpaceFaces,
    HelpPopover
  },
  props: {
    withHeader: { type: Boolean, default: true },
    withClose: { type: Boolean, default: false },
    withBack: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    backText: { type: String, default: 'Cancel' },
    context: { type: String },
    initialClient: { type: Object, required: false },
    relationshipId: { default: -1 },
    touch: { type: Number, default: 1 },
    title: { type: String, default: 'Create a new client' }
  },
  data () {
    let vm = this
    return {
      rules: RULES,
      reqId: 'create-client-request',
      showMatchingClients: false,
      updateAppointments: true,
      contactSelectedPhone: null,
      contactSelectedEmail: null,
      savedContact: null,
      showContactClient: false,
      isValidPhoneNumber: false,
      showExtra: false,
      valid: false,
      sharing: [],
      client: {
        full_name: '',
        email: '',
        phone_number: '',
        custom_id: '',
        nickname: '',
        id: -1,
        spaces: [],
        context: 'SPACE'
      },
      contactClient: {
        name: {},
        phoneNumbers: [],
        emails: []
      },
      activeWindow: CREATE_CLIENT_WINDOW,
      showSuccess: false,
      actions: [
        {
          icon: 'arrow_forward',
          title: 'Go to client page',
          onclick: (client) => {
            this.$emit('close')
            this.gotoClient(client)
          }
        },
        {
          icon: 'info',
          title: 'Add more information',
          subtitle: 'Medical aid details, billing address etc',
          onclick: (client) => {
            vm.launchCustomerDetailsDialog(client.id)
          }
        },
        {
          icon: 'alarm_add',
          title: 'Create appointment',
          subtitle: 'Create an appointment for this client',
          onclick: (client) => {
            let options = {relationship: client}
            vm.launchCreateAppointment({options})
          }
        },
        {
          icon: 'add',
          title: 'Add another',
          subtitle: 'Add another client',
          onclick: (client) => {
            vm.clear()
            vm.activeWindow = CREATE_CLIENT_WINDOW
            vm.savedContact = null
          }
        },
        {
          id: 'done',
          icon: 'check',
          title: 'Done',
          subtitle: 'Get back to what you were doing before!',
          onclick: (client) => {
            vm.$emit('close')
          }
        }
      ]
    }
  },
  mounted () {
    if (this.initialClient) {
      this.fromClientObject(this.initialClient)
    }
    // this.showContactClient = true
    // this.contactClient = {
    //   'name': {
    //     'givenName': 'Achoo',
    //     'formatted': 'Achoo'
    //   },
    //   'phoneNumbers': [{
    //     'value': '(074) 4420290'
    //   }],
    //   'emails': null
    // }
  },
  watch: {
    touch () {
      this.clear()
      this.activeWindow = CREATE_CLIENT_WINDOW
    },
    clientEmail () {
      if (this.client && !this.isRealEmail(this.clientEmail)) {
        this.client.email = ''
      }
    },
    requestLoading () {
      this.$emit('update:loading', this.requestLoading)
    },
    createRequestStatus () {
      if (this.createRequestStatus === 201) {
        let clientData = this.createRequest.result.data
        this.$store.commit('addClient', clientData)
        this.$emit('client:created', clientData)
        this.notify('New client created.', 'success')
        this.clear()
        this.savedContact = clientData
        this.activeWindow = CLIENT_SUCCESS_WINDOW

        // let parsedClient = {
        //   id: new Date().getTime(),
        //   client: clientData
        // }
        // this.getClients()
        // setTimeout(() => {
        //   this.openGlobalDialog(false)
        // }, DEFAULT_TIMEOUT)
      }
      if (this.createRequestStatus === 200) {
        let clientData = this.createRequest.result.data
        console.log('req:200', clientData)
        this.$store.commit('addClient', clientData)
        // this.savedContact = clientData
        this.$emit('client:updated', clientData)
        this.notify('Client updated.', 'success')
        this.getAppointmentsInRange()
        // this.savedContact = clientData
        // this.clear()
      }
    },
    initialClientId () {
      console.log('initial', this.initialClientId)
      if (this.initialClient) {
        this.fromClientObject(this.initialClient)
      }
    } // ,
    // contactClient () {
    //   this.clear()
    //   if (this.contactClient && this.contactClient.name) {
    //     // Vue.set(this.client, 'full_name', this.contactClient.name.formatted)
    //     this.client.full_name = this.contactClient.name.formatted
    //   }
    //   if (this.contactClient &&
    //       this.contactClient.emails &&
    //       this.contactClient.emails.length > 0) {
    //     this.client.email = this.contactClient.emails[0].value
    //     // Vue.set(this.client, 'email', this.contactClient.emails[0].value)
    //   }
    //   if (this.contactClient &&
    //       this.contactClient.phoneNumbers &&
    //       this.contactClient.phoneNumbers.length > 0) {
    //     // console.log('selected number', this.contactClient.phoneNumbers[0].value)
    //     this.contactSelectedPhone = this.contactClient.phoneNumbers[0].value
    //     // this.client.phone_number = this.contactClient.phoneNumbers[0].value
    //     // Vue.set(this.client, 'phone_number', this.contactClient.phoneNumbers[0].value)
    //   }
    // }
  },
  computed: {
    initialClientId () {
      if (this.initialClient) {
        return this.initialClient.id
      }
    },
    hasContacts () {
      return (navigator && navigator.contacts)
    },
    sharedSpaceIds () {
      if (this.client && this.client.spaces && this.client.spaces.length > 0) {
        return this.client.spaces.join(',')
        // return this.client.spaces.join(',').map((item) => { return item.id }).join(',')
      }
      return []
    },
    btnTxt () {
      if (this.editMode) {
        return 'Save'
      }
      return 'Create'
    },
    dirty () {
      let initialClientData = `${this.initialClient.email}.${this.initialClient.phone_number}`
      let clientData = `${this.client.email}.${this.client.phone_number}`
      return (initialClientData !== clientData)
    },
    requestLoading () {
      if (this.createRequest) {
        return this.createRequest.loading
      }
      return false
    },
    editMode () {
      return this.relationshipId !== -1
    },
    createRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    fullPhoneNumber () {
      return '+' + this.client.phone_number
    },
    parsedPhoneNumber () {
      let n = parse(this.fullPhoneNumber)
      return n
    },
    formattedPhoneNumber () {
      if (this.isValidPhoneNumber === true) {
        return format(this.parsedPhoneNumber, 'International_plaintext')
      }
    },
    createRequestStatus () {
      return this.createRequest.status
    },
    clientEmail () {
      if (this.client) {
        return this.client.email
      }
    },
    clientFormatted () {
      // let data = this.client
      let data = {}
      data['phone_number'] = this.contactSelectedPhone
      data['email'] = this.client.email
      data['full_name'] = this.client.full_name
      data['nickname'] = this.client.nickname
      data['custom_id'] = this.client.custom_id
      data['first_name'] = this.firstName
      data['last_name'] = this.lastName
      data['id'] = this.client.id
      data['spaces'] = this.sharedSpaceIds
      data['context'] = 'SPACE'
      data['with_blank_user'] = true
      if (this.updateAppointments) {
        data['update_appointments'] = true
      }
      return data
    },
    validContextSharing () {
      if (this.client.context === 'SPACE') {
        return (this.sharedSpaceIds && this.sharedSpaceIds.length > 0)
      }
      return true
    },
    clientIsValid () {
      //  && this.isValidPhoneNumber
      return (this.validContextSharing && this.clientFormatted.full_name)
    },
    singleErrorMessage () {
      if (!this.validContextSharing) {
        return 'You must share with at least 1 space'
      }
      if (!this.clientFormatted.full_name) {
        return 'Full name (or at least a first name!) is required'
      }
    },
    hasSomeContactDetails () {
      return (this.clientFormatted.email || this.clientFormatted.phone_number)
    },
    firstName () {
      if (this.client.full_name) {
        return this.client.full_name.split(' ', 1).pop()
      }
    },
    lastName () {
      if (this.client.full_name) {
        return this.client.full_name.split(' ').splice(1).join(' ')
      }
    },
    allClients () {
      return this.$store.getters.clients
    },
    matchingClients () {
      let vm = this
      let clients = this.allClients
      if (clients) {
        return clients.filter((client) => {
          let item = client.client
          if (item.phone_number &&
              vm.client.phone_number &&
              vm.client.phone_number.length > 5 &&
              item.phone_number.indexOf(vm.client.phone_number) !== -1) {
            return client
          }
          if (item.first_name &&
              vm.client.full_name &&
              vm.client.full_name.length > 2 &&
              item.first_name.toLowerCase().indexOf(vm.client.full_name.toLowerCase()) !== -1) {
            return client
          }
          if (item.last_name &&
              vm.client.full_name &&
              vm.client.full_name.length > 2 &&
              item.last_name.toLowerCase().indexOf(vm.client.full_name.toLowerCase()) !== -1) {
            return client
          }
          if (item.email &&
              vm.client.email &&
              vm.client.email.length > 3 &&
              item.email.toLowerCase().indexOf(vm.client.email) !== -1) {
            return client
          }
        })
      }
      return []
    }
  },
  methods: {
    setClientPhone (number) {
      // console.log('number', number)
      this.client.phone_number = number
    },
    setValidPhoneNumber (isValid) {
      this.isValidPhoneNumber = isValid
    },
    setSelectedNumber (number) {
      this.contactSelectedPhone = ''
      // horrible hack for crazy ass ios bug
      let vm = this
      setTimeout(() => {
        vm.contactSelectedPhone = number
      }, 10)
    },
    pickContact () {
      let vm = this
      vm.clear()
      vm.showContactClient = false
      vm.contactClient = {
        name: null,
        emails: [],
        phoneNumbers: []
      }
      navigator.contacts.pickContact(
        function (contact) {
          vm.contactClient.name = contact.name
          if (contact.name) {
            vm.client.full_name = contact.name.formatted
          }
          // console.log(contact)
          // console.log(vm.contactClient)
          if (contact.phoneNumbers && contact.phoneNumbers.length > 0) {
            for (let number of contact.phoneNumbers) {
              vm.contactClient.phoneNumbers.push(number.value)
            }
            vm.contactSelectedPhone = vm.contactClient.phoneNumbers[0]
          }
          if (contact.emails && contact.emails.length > 0) {
            for (let email of contact.emails) {
              vm.contactClient.emails.push(email.value)
            }
            vm.client.email = vm.contactClient.emails[0]
          }
          // console.log(vm.contactClient)
          vm.showContactClient = true
          // console.log(vm.contactClient.phoneNumbers)
        },
        function (err) {
          // window.alert('Unable to load contact')
          console.log('Error: ' + err)
        }
      )
    },
    fromClientObject (clientObj) {
      if (this.client && clientObj) {
        console.log('fromclientobj', clientObj)
        this.client.full_name = `${clientObj.first_name} ${clientObj.last_name}`
        this.contactSelectedPhone = clientObj.phone_number
        if (clientObj.phone_number && clientObj.phone_number.startsWith('+')) {
          this.client.phone_number = this.client.phone_number.substr(1)
        }
        this.client.email = clientObj.email
        this.client.custom_id = clientObj.custom_id
        this.client.nickname = clientObj.nickname
        if (clientObj.context) {
          // NB: context.sycn
          this.client.context = clientObj.context
        }
        if (this.context) { Vue.set(this.client, 'context', this.context) }
        if (clientObj.nickname || clientObj.custom_id) {
          this.showExtra = true
        }
        this.client.spaces = clientObj.spaces
      }
    },
    clear () {
      this.client.full_name = ''
      this.contactSelectedPhone = ''
      this.client.email = ''
      this.client.custom_id = ''
      this.client.nickname = ''
      this.client.spaces = []
      // Vue.set(this.client, 'full_name', '')
      // Vue.set(this.client, 'email', '')
      // Vue.set(this.client, 'phone_number', '')
    },
    save () {
      // prevent double save
      if (this.requestLoading) { return false }
      let data = JSON.stringify(this.clientFormatted)
      if (this.editMode) {
        this.$appointmentguru
          .resource('practitioner.clients')
          .id(this.reqId)
          .save(this.relationshipId, data)
      } else {
        this.$appointmentguru
          .resource('practitioner.clients.new')
          .id(this.reqId)
          .create(data)
      }
    }
  },
  i18n: {
    messages: {
      en: {
      }
    }
  }
}
/*

*/
</script>

<style>

</style>



// WEBPACK FOOTER //
// Create.vue?438e7a71